import React from "react";
import { TableCell } from "@mui/material";

import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { sortIconSx,handleSort } from '.';


const WidgetsSortingComponent = (
   { sortableColumns,
    sortConfig,
    setSortConfig}) => {
    return (
        <>
            {sortableColumns.map((col) => {
                const isActive = sortConfig.key === col.key;
                const isAsc = sortConfig.direction === "asc";

                return (
                    <TableCell
                        onClick={() =>
                            handleSort(col.key, sortConfig, setSortConfig)
                        }
                        sx={{
                            cursor: "pointer",
                            userSelect: "none",
                            position: "relative",
                            "&:hover .sortIcon": { opacity: 0.6 },
                        }}
                    >
                        {col.label}
                        {isActive ? (
                            isAsc ? (
                                <ArrowUpwardIcon
                                    className="sortIcon"
                                    sx={{
                                        ...sortIconSx,
                                        opacity: 1,
                                        color: "primary.main",
                                    }}
                                />
                            ) : (
                                <ArrowDownwardIcon
                                    className="sortIcon"
                                    sx={{
                                        ...sortIconSx,
                                        opacity: 1,
                                        color: "primary.main",
                                    }}
                                />
                            )
                        ) : (
                            <ArrowUpwardIcon
                                className="sortIcon"
                                sx={sortIconSx}
                            />
                        )}
                    </TableCell>
                );
            })}
        </>
    );
};

export default WidgetsSortingComponent;
